export type LatLng = {lat: number; lng: number};

/** Parse API `"lat,lng"` (optional spaces). */
export function parseGpsLatLng(raw: string | null | undefined): LatLng | null {
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  if (!trimmed) return null;
  const parts = trimmed.split(",");
  if (parts.length < 2) return null;
  const lat = Number.parseFloat(parts[0].trim());
  const lng = Number.parseFloat(parts[1].trim());
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return {lat, lng};
}

export function googleMapsDirectionsUrl({lat, lng}: LatLng): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
}

export function wazeNavigateUrl({lat, lng}: LatLng): string {
  return `https://waze.com/ul?ll=${lat}%2C${lng}&navigate=yes`;
}

export function openExternalUrl(url: string): void {
  window.open(url, "_blank", "noopener,noreferrer");
}
